import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ToastNotificationService } from '../toast-notification.service';
import { AuthService } from '../../auth/service/auth.service';
import { Observable } from 'rxjs';
import { Resource } from '../../../interfaces/resource';
import { FetchUserService } from '../../fetchServices/fetchUser/fetch-user.service';

@Injectable({
  providedIn: 'root'
})
export class EventHistoryService {

  apiUrl: string = environment.apiUrl;
    testApi = 'https://test.api.tridimo.de/api/';
    devApi = 'https://dev.api.tridimo.de/api/';
    storedData: any
    private eventHistoryBuffer: any[] = [];
       authUser: any

 
   constructor(private http: HttpClient, private authService: AuthService, private toastService: ToastNotificationService, private fetchUserService: FetchUserService) { }
 
   async getStoredData() {
     this.storedData = localStorage.getItem("authUser"); 
   }
 
   checkToken(token: any) {
     try {
       const expirationTime = token * 1000;
       const currentTime = Date.now();
       if (currentTime > expirationTime) {
         console.log('Token ist älter als 60 Minuten');
         this.logout()
       } else {
         console.log('Token ist noch gültig');
       }
     } catch (e) {
       console.error('Fehler beim Dekodieren des Tokens:', e);
       this.logout()
     }
   }
 
 
   logout() {
     //localStorage.clear();
     sessionStorage.clear();
     this.authService.logout();
   }
 
 
   setFetchOptions() {
     let options: any = {};
     
     if (this.apiUrl === this.devApi ) {
       let token = "";
       let exp = '';
       this.getStoredData();
       if (this.storedData) {
         try {
           const parsedData = JSON.parse(this.storedData);
           token = parsedData.token;
           exp = parsedData.exp;
           this.checkToken(exp);
         } catch (error) {
           console.error("Fehler beim Parsen des Tokens:", error);
           this.logout();
         }
       } else {
         this.logout();
         console.log("Kein Token im Local Storage gefunden.");
       }
   
       const headers = new HttpHeaders({
         'Authorization': `${token}`,
         'Content-Type': 'application/json'
       });
       
       options.headers = headers;
     } else {
         options.withCredentials = true;
     }
     
     return options;
   }

   uploadEventHistory(id: any, fieldName: any, newValue: any, oldValue: any, action: any) {
    
    if (fieldName === 'resource') {
      if (Array.isArray(newValue) && newValue.length === 0) {
        newValue = 0;
      }
      if (Array.isArray(oldValue) && oldValue.length === 0) {
        oldValue = 0;
      }
    }
  
    const eventInfo = {
      action: action,
      eventID: id,
      fieldName: fieldName,
      fieldValueFrom: oldValue,
      fieldValueTo: newValue,
    };
  
    const options = this.setFetchOptions();
    this.http.post(`${this.apiUrl}eventhistory`, eventInfo, options).subscribe({
      next: (response) => console.log("Event update successfully:", response),
      error: (error) => console.error("Error updating event:", error)
    });
  }

uploadBufferedEventHistory() {
  if (this.eventHistoryBuffer.length === 0) {
    console.log("Keine Änderungen im Puffer, nichts zu senden.");
    return;
  }

  const payload = { history: [...this.eventHistoryBuffer] }; // 👈 Hier geändert!
  this.eventHistoryBuffer = [];

  const options = this.setFetchOptions();

  this.http.post(`${this.apiUrl}eventhistory/bulk`, payload, options).subscribe({
    next: (response) => console.log("Bulk-Upload erfolgreich:", response),
    error: (error) => console.error("Fehler beim Bulk-Upload:", error)
  });
}

  

 fetchEventHistory(id: any): Observable<any> {
     const options = this.setFetchOptions();
     console.log(options)
     console.log('FETCH OPTIONS: ',options)
     return this.http.get(`${this.apiUrl}eventhistory/${id}`, options).pipe(
       // catchError((error: HttpErrorResponse) => {
       //   if (error.status === 401) {
       //     console.log("Unauthorized: Logging out");
       //     this.toastService.dangerToast(`Fehler beim laden der Termine, kein Token gefunden`);
       //     this.logout();  // Falls 401, führe logout aus
       //   } else {
       //     this.toastService.dangerToast(`Fehler beim laden der Termine`);
       //   }
       //   return of(null);
       // })
     );
   }


   // ===================== Helper =====================

// 0/1/"0"/"1"/"true"/"false" -> bool | '' normalisieren
private normalizePrimitive(val: any): any {
  if (val === '0' || val === 0) return false;
  if (val === '1' || val === 1) return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val ?? '';
}

private canonicalizeOnlineLinks(val: any): { platform: string; link: string; description: string }[] {
  if (!val) return [];
  const arr = Array.isArray(val) ? val : [val];

  return arr
    .filter(Boolean)
    .map((x: any) => ({
      platform: String(x?.platform ?? '').trim(),
      link: String(x?.link ?? '').trim(),
      description: String(x?.description ?? '').trim(),
    }))
    // nur Einträge behalten, die nicht komplett leer sind
    .filter(x => x.platform || x.link || x.description)
    // sortiert nach Plattform + Link → Reihenfolge egal
    .sort((a, b) =>
      (a.platform || '').localeCompare(b.platform || '') ||
      (a.link || '').localeCompare(b.link || '')
    );
}

private onlineLinksToDisplay(val: any): string {
  const items = this.canonicalizeOnlineLinks(val);
  if (!items.length) return '';
  return items
    .map(i => {
      const plat = i.platform || 'Link';
      if (i.link && i.description) return `${plat}: ${i.link} (${i.description})`;
      if (i.link) return `${plat}: ${i.link}`;
      if (i.description) return `${plat} (${i.description})`;
      return plat;
    })
    .join(' • ');
}

// resource zu ID-Array normalisieren (unterstützt "8,11", ["8","11"], [8,11], [{id:8},{id:11}])
private normalizeResourceIds(val: any): number[] {
  if (val == null || val === '') return [];
  let arr: any[] = Array.isArray(val) ? val : String(val).split(',');
  arr = arr
    .map(v => (typeof v === 'object' ? v?.id : v))
    .map(v => Number(String(v).trim()))
    .filter(v => Number.isFinite(v));
  const unique = Array.from(new Set(arr)).sort((a, b) => a - b);
  return unique;
}

// customer zu ID-Array normalisieren (unterstützt [{id:..}, ..] und [id, id])
private normalizeCustomerIds(val: any): number[] {
  if (!Array.isArray(val)) return [];
  const ids = val.map(v => (typeof v === 'object' ? v?.id : v))
                 .map(v => Number(v))
                 .filter(v => Number.isFinite(v));
  const uniqueSorted = Array.from(new Set(ids)).sort((a, b) => a - b);
  return uniqueSorted;
}

// generische Normalisierung für Vergleiche (deterministisches JSON)
private normalizeForCompare(val: any, key?: string): any {
  // bool/0/1-Logik
  const prim = this.normalizePrimitive(val);

  // Spezialfälle nach Key
  if (key === 'onlineLink') return this.canonicalizeOnlineLinks(prim);
  if (key === 'resource')   return this.normalizeResourceIds(prim);
  if (key === 'customer')   return this.normalizeCustomerIds(prim);

  // Arrays/Objekte stabilisieren
  if (Array.isArray(prim)) return prim.map(v => this.normalizeForCompare(v, key));
  if (prim && typeof prim === 'object') {
    const sorted: any = {};
    Object.keys(prim).sort().forEach(k => sorted[k] = this.normalizeForCompare(prim[k], k));
    return sorted;
  }

  return prim;
}

// Anzeige-String (benutzerfreundlich) – nutzt Spezialfälle
private toDisplayString(val: any, key?: string): string {
  if (val == null) return '';

  if (key === 'onlineLink') return this.onlineLinksToDisplay(val);
  if (key === 'resource')   return this.normalizeResourceIds(val).join(', ');
  if (key === 'customer')   return this.normalizeCustomerIds(val).join(', ');

  if (Array.isArray(val)) return val.map(v => this.toDisplayString(v, key)).filter(Boolean).join(', ');
  if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean') return String(val);

  try {
    const s = JSON.stringify(val);
    return s.length > 500 ? s.slice(0, 500) + '…' : s;
  } catch {
    return String(val);
  }
}

myResources: Resource[] = [];

async fetchInterpreters(): Promise<void> {
  return new Promise((resolve, reject) => {
    this.fetchUserService.fetchInterpreters().subscribe({
      next: (users: any) => {
        this.myResources = users.map((user: any) => ({
          id: user.id,
          cr: user.abbreviation,
          name: `${user.firstName.trim()} ${user.lastName}`,
          color: user.color,
          img: user.img,
          workingHours: user.workingHours,
          workingType: user.workingType,
          team: user.team
        }));
        resolve();
      },
      error: (err) => {
        console.error("Fehler beim Abrufen der Dolmetscher:", err);
        reject(err);
      }
    });
  });
}

async compareAndUploadChanges(original: any, updated: any, eventId: any, action: any) {
  console.log('Original:', original);
  console.log('Aktualisiert:', updated);

  // 🧭 Dolmetscher laden (falls noch nicht)
  if (this.myResources.length === 0) {
    await new Promise<void>((resolve, reject) => {
      this.fetchUserService.fetchInterpreters().subscribe({
        next: (users: any) => {
          this.myResources = users.map((user: any) => ({
            id: user.id,
            cr: user.abbreviation,
            name: `${user.firstName.trim()} ${user.lastName}`,
            color: user.color,
            img: user.img,
            workingHours: user.workingHours,
            workingType: user.workingType,
            team: user.team
          }));
          resolve();
        },
        error: (err) => {
          console.error('Fehler beim Abrufen der Dolmetscher:', err);
          reject(err);
        }
      });
    });
  }

  // 🔐 User laden
  const authUserString = localStorage.getItem('authUser');
  if (authUserString) {
    this.authUser = JSON.parse(authUserString);
  }

  // 🔒 Guards
  if (!original || !updated) {
    console.error('Fehler: Original- oder aktualisierte Event-Daten fehlen.');
    return;
  }

  // 🔧 Event-ID säubern
  if (typeof eventId === 'string' && eventId.includes('-')) {
    eventId = eventId.split('-')[0];
  }

  const fieldNameMap: Record<string, string> = {
    category: 'Kategorie',
    customer: 'Kunde',
    description: 'Beschreibung',
    dolmetscher: 'Dolmetscher Anzahl',
    end: 'Endzeit',
    eventResources: 'Dolmetscher',
    resource: 'Dolmetscher',
    informations: 'Informationen',
    location: 'Adresse',
    online: 'Online Termin',
    onlineLink: 'Online-Links',
    start: 'Startzeit',
    status: 'Status',
    ticketno: 'Ticketnummer',
    title: 'Titel',
    vorbereitungsmaterial: 'Vorbereitungsmaterial',
    vorbereitungsmaterialLink: 'Vorbereitungsmaterial Link',
    subtypes: 'Unterkategorie',
    dialinTime: 'Einwahlzeit',
    minuteBased: 'Minutengenaue',
    calculateTraveltime: 'Fahrzeit berechnen'
  };

  const excludedFields = [
    'bestaetigungsform', 'blocker', 'blockerRef', 'bufferAfter', 'bufferBefore',
    'color', 'cost', 'createdAt', 'deleted', 'einsatzzeit',
    'hasEarlierSameDayEvent', 'hastNextSameDayEvent', 'id', 'isTempEvent',
    'nextEventLocation', 'offeneTermine', 'previousEventLocation',
    'refId', 'traveltime', 'traveltimeAfter', 'traveltimeBefore', 'type',
    'recurring', 'recurringException'
  ];

  // ===================== Helper =====================

  const canonicalizeInformations = (val: any) => {
  if (!Array.isArray(val)) return [];
  const arr = val
    .filter(Boolean)
    .map((x: any) => ({
      title: String(x?.title ?? '').trim(),
      checked: !!x?.checked,
      type: String(x?.type ?? '').trim(),
      icon_name: String(x?.icon_name ?? '').trim(),
      info: String(x?.info ?? '').trim(),       // 🆕 hinzugefügt
      value: String(x?.value ?? '').trim(),     // 🆕 hinzugefügt
      options: Array.isArray(x?.options)
        ? x.options.map((o: any) => ({
            name: String(o?.name ?? '').trim(),
            info: String(o?.info ?? '').trim()
          }))
        : []
    }));
  arr.sort((a, b) => a.title.localeCompare(b.title));
  return arr;
};


  const informationsToDisplay = (val: any): string => {
    const items = canonicalizeInformations(val);
    if (!items.length) return '';
    return items.map(info => {
      const state = info.checked ? 'Ja' : 'Nein';
      const optText =
        info.options && info.options.length > 0
          ? ` [${info.options
              .map((o: any) => `${o.name || ''} ${o.info || ''}`.trim())
              .filter(Boolean)
              .join('; ')}]`
          : '';
      return `${info.title} (${state})${optText}`;
    }).join(' • ');
  };

  const canonicalizeOnlineLinks = (val: any) => {
    if (!val) return [];
    const arr = Array.isArray(val) ? val : [val];
    return arr
      .filter(Boolean)
      .map((x: any) => ({
        platform: String(x?.platform ?? '').trim(),
        link: String(x?.link ?? '').trim(),
        description: String(x?.description ?? '').trim()
      }))
      .filter(x => x.platform || x.link || x.description)
      .sort((a, b) =>
        (a.platform || '').localeCompare(b.platform || '') ||
        (a.link || '').localeCompare(b.link || '')
      );
  };

  const onlineLinksToDisplay = (val: any): string => {
    const items = canonicalizeOnlineLinks(val);
    if (!items.length) return '';
    return items.map(i => {
      const plat = i.platform || 'Link';
      if (i.link && i.description) return `${plat}: ${i.link} (${i.description})`;
      if (i.link) return `${plat}: ${i.link}`;
      if (i.description) return `${plat} (${i.description})`;
      return plat;
    }).join(' • ');
  };

  const normalizeCustomerIds = (val: any): number[] => {
    if (!Array.isArray(val)) return [];
    const ids = val.map(v => (typeof v === 'object' ? v?.id : v))
                   .map(v => Number(v))
                   .filter(v => Number.isFinite(v));
    return Array.from(new Set(ids)).sort((a, b) => a - b);
  };

  const normalizeResourceIds = (val: any): number[] => {
    if (val == null || val === '') return [];
    let arr: any[] = Array.isArray(val) ? val : String(val).split(',');
    arr = arr
      .map(v => (typeof v === 'object' ? v?.id : v))
      .map(v => Number(String(v).trim()))
      .filter(v => Number.isFinite(v));
    return Array.from(new Set(arr)).sort((a, b) => a - b);
  };

  const toDisplayString = (val: any, key?: string): string => {
  if (val == null) return '';
  if (key === 'onlineLink') return onlineLinksToDisplay(val);

  if (key === 'resource') {
    const ids = normalizeResourceIds(val);
    if (!ids.length) return '';
    const names = ids.map(id => {
      const found = this.myResources.find(r => r.id === id);
      return found ? found.name : `#${id}`;
    });
    return names.join(', ');
  }

  // 🟣 Unterkategorie / Subtypes
  if (key === 'subtypes') {
    if (val === null || val === undefined || val === 0 || val === '0') return 'keiner';
    if (val === 1 || val === '1') return 'Übung';
    if (val === 2 || val === '2') return 'Entwicklungszeit';
    return String(val);
  }

  // 🟢 Dolmetscher Anzahl: Zahl direkt anzeigen
  if (key === 'dolmetscher') {
    return val === '' || val === null || val === undefined ? '' : String(val);
  }

  // ✅ Ja/Nein-Felder (für alles andere)
  if (val === true || val === 'true' || val === 1 || val === '1') return 'Ja';
  if (val === false || val === 'false' || val === 0 || val === '0') return 'Nein';

  if (Array.isArray(val))
    return val.map(v => toDisplayString(v, key)).filter(Boolean).join(', ');

  if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean')
    return String(val);

  try {
    return JSON.stringify(val);
  } catch {
    return String(val);
  }
};


  const normalizePrimitive = (val: any): any => {
    if (val === '0' || val === 0) return false;
    if (val === '1' || val === 1) return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val ?? '';
  };

  const normalizeForCompare = (val: any, key?: string): any => {
    const prim = normalizePrimitive(val);
    if (key === 'onlineLink') return canonicalizeOnlineLinks(prim);
    if (key === 'resource') return normalizeResourceIds(prim);
    if (key === 'customer') return normalizeCustomerIds(prim);
    if (Array.isArray(prim)) return prim.map(v => normalizeForCompare(v, key));
    if (prim && typeof prim === 'object') {
      const sorted: any = {};
      Object.keys(prim).sort().forEach(k => (sorted[k] = normalizeForCompare(prim[k], k)));
      return sorted;
    }
    return prim;
  };

  // ===================== Vergleich =====================
  if (action === 'changed') {
    Object.keys(updated).forEach(key => {
      if (excludedFields.includes(key)) return;

      const oldValue = original[key];
      const newValue = updated[key];

     // 🟢 Dolmetscher (eventResources ↔ resource)
// 🟢 Dolmetscher (eventResources ↔ resource)
if (key === 'resource') {
  const oldRes = normalizeResourceIds(original.eventResources || original.resource || []);
  const newRes = normalizeResourceIds(updated.resource || []);

  if (JSON.stringify(oldRes) !== JSON.stringify(newRes)) {
    const oldNames = oldRes
      .map(id => this.myResources.find(r => r.id === id)?.name || `#${id}`)
      .join(', ');
    const newNames = newRes
      .map(id => this.myResources.find(r => r.id === id)?.name || `#${id}`)
      .join(', ');

    // 🧭 Logik für Backlog <-> Dolmetscher
    let fieldValueFrom = oldNames || '-';
    let fieldValueTo = newNames || '-';

    if (oldRes.length > 0 && newRes.length === 0) {
      // Dolmetscher wurde entfernt → Backlog
      fieldValueTo = 'Backlog';
    } else if (oldRes.length === 0 && newRes.length > 0) {
      // Aus Backlog einem Dolmetscher zugewiesen
      fieldValueFrom = 'Backlog';
    }

    this.eventHistoryBuffer.push({
      userID: this.authUser?.user?.id,
      eventID: eventId,
      fieldName: fieldNameMap['resource'] || 'resource',
      fieldValueFrom,
      fieldValueTo,
      action
    });
  }
  return;
}



      // 🧹 eventResources nicht doppelt loggen
      if (key === 'eventResources') return;

      // 🟡 Kunde ignorieren bei leer/0
      // 🟡 Kunde ignorieren, wenn leer/0 oder ungültig
if (key === 'customer') {
  const oldIds = normalizeCustomerIds(oldValue);
  const newIds = normalizeCustomerIds(newValue);

  // ➤ Verhindere Eintrag, wenn alt und neu leer oder "0" sind
  const oldStr = oldIds.join(',') || String(oldValue || '').trim();
  const newStr = newIds.join(',') || String(newValue || '').trim();

  if (
    (!oldIds.length && !newIds.length) ||
    oldStr === '0' || newStr === '0' ||
    JSON.stringify(oldIds) === JSON.stringify(newIds)
  ) {
    return;
  }

  this.eventHistoryBuffer.push({
    userID: this.authUser?.user?.id,
    eventID: eventId,
    fieldName: fieldNameMap[key] || key,
    fieldValueFrom: oldIds.join(', ') || '-',
    fieldValueTo: newIds.join(', ') || '-',
    action
  });
  return;
}


      // 🟢 Online-Link
      if (key === 'onlineLink') {
        const oldLinks = canonicalizeOnlineLinks(oldValue);
        const newLinks = canonicalizeOnlineLinks(newValue);
        if (oldLinks.length !== newLinks.length || JSON.stringify(oldLinks) !== JSON.stringify(newLinks)) {
          this.eventHistoryBuffer.push({
            userID: this.authUser?.user?.id,
            eventID: eventId,
            fieldName: fieldNameMap[key] || key,
            fieldValueFrom: onlineLinksToDisplay(oldValue),
            fieldValueTo: onlineLinksToDisplay(newValue),
            action
          });
        }
        return;
      }

      // 🕒 Spezialfall: Startzeit & Endzeit (Date-Vergleich)
if (key === 'start' || key === 'end') {
  const oldDate = oldValue ? new Date(oldValue) : null;
  const newDate = newValue ? new Date(newValue) : null;

  const oldIso = oldDate instanceof Date && !isNaN(oldDate.getTime())
    ? oldDate.toISOString()
    : String(oldValue || '');
  const newIso = newDate instanceof Date && !isNaN(newDate.getTime())
    ? newDate.toISOString()
    : String(newValue || '');

  // Nur loggen, wenn sich die Zeit wirklich geändert hat
  if (oldIso !== newIso) {
    const displayOld = oldDate
      ? oldDate.toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' })
      : '-';
    const displayNew = newDate
      ? newDate.toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' })
      : '-';

    this.eventHistoryBuffer.push({
      userID: this.authUser?.user?.id,
      eventID: eventId,
      fieldName: fieldNameMap[key] || key,
      fieldValueFrom: displayOld,
      fieldValueTo: displayNew,
      action
    });
  }
  return;
}


      // 🟢 Informations – einzeln loggen, inkl. Radio-Gruppen und Zusatzfelder
if (key === 'informations') {
  const oldInfos = canonicalizeInformations(oldValue);
  const newInfos = canonicalizeInformations(newValue);

  // 🔹 1. Aktive Radios ermitteln (über checked oder value)
  const getActiveRadio = (infos: any[]) => {
    const radios = infos.filter(i => i.type === 'radio');
    if (!radios.length) return null;

    // Erst nach "checked" suchen, sonst value oder title
    const active = radios.find(i => i.checked) || null;
    if (active) return active.value || active.title || null;

    const val = radios.find(i => i.value)?.value || null;
    return val;
  };

  const oldActiveRadio = getActiveRadio(oldInfos);
  const newActiveRadio = getActiveRadio(newInfos);

  // 🔹 1.1 Übersetzung der Radio-Werte (m / w)
  const translateGender = (val: string | null): string => {
    if (!val) return '-';
    const lower = val.toLowerCase();
    if (lower === 'm') return 'Männlicher Dolmetscher';
    if (lower === 'w') return 'Weiblicher Dolmetscher';
    return val; // falls andere Radios existieren
  };

  const oldGender = translateGender(oldActiveRadio);
  const newGender = translateGender(newActiveRadio);

  // Wenn sich der aktive Radio geändert hat (z. B. m → w)
  if (oldGender !== newGender) {
    this.eventHistoryBuffer.push({
      userID: this.authUser?.user?.id,
      eventID: eventId,
      fieldName: `${fieldNameMap[key] || key}: Auswahl`,
      fieldValueFrom: oldGender || '-',
      fieldValueTo: newGender || '-',
      action
    });
  }

  // 🔹 2. Andere Typen (checkbox, switch, select, etc.) weiterhin einzeln loggen
  const nonRadios = new Set([
    ...oldInfos.filter(i => i.type !== 'radio').map(i => i.title),
    ...newInfos.filter(i => i.type !== 'radio').map(i => i.title)
  ]);

  for (const title of nonRadios) {
  const oldInfo = oldInfos.find(i => i.title === title);
  const newInfo = newInfos.find(i => i.title === title);

  // 🧩 Hilfsfunktion: baut Textdarstellung eines Info-Objekts
  const display = (i: any): string => {
    if (!i) return 'Nein'; // ❗ neu: kein Eintrag = Nein

    const parts: string[] = [];

    // Checkbox / Switch = Ja / Nein
    if (i.type === 'checkbox' || i.type === 'switch') {
      parts.push(i.checked ? 'Ja' : 'Nein');
    }

    // Select = Auswahl
    if (i.type === 'select') {
      parts.push(`Auswahl: ${i.value || '-'}`);
    }

    // Radio wird hier nicht behandelt (oben erledigt)

    // Zusatzinfos (Textfelder)
    if (i.info && String(i.info).trim()) {
      parts.push(`Info: ${String(i.info).trim()}`);
    }

    // Optionen
    if (Array.isArray(i.options) && i.options.length) {
      const opt = i.options
        .map((o: any) => `${o?.name || ''} ${o?.info || ''}`.trim())
        .filter(Boolean)
        .join(' ; ');
      if (opt) parts.push(opt);
    }

    // Wenn keine Infos gesammelt → Nein
    return parts.length ? parts.join(' | ') : 'Nein';
  };

  const oldDisplay = display(oldInfo);
  const newDisplay = display(newInfo);

  // Nur loggen, wenn sich etwas sichtbar geändert hat
  if (oldDisplay !== newDisplay) {
    this.eventHistoryBuffer.push({
      userID: this.authUser?.user?.id,
      eventID: eventId,
      fieldName: `${fieldNameMap[key] || key}: ${title}`,
      fieldValueFrom: oldDisplay,
      fieldValueTo: newDisplay,
      action
    });
  }
}


  return;
}




      // 🔸 Standard-Felder
      const normOld = normalizeForCompare(oldValue, key);
      const normNew = normalizeForCompare(newValue, key);
      if (JSON.stringify(normOld) === JSON.stringify(normNew)) return;

      const displayOld = toDisplayString(oldValue, key);
      const displayNew = toDisplayString(newValue, key);
      if (displayOld === displayNew) return;

      this.eventHistoryBuffer.push({
        userID: this.authUser?.user?.id,
        eventID: eventId,
        fieldName: fieldNameMap[key] || key,
        fieldValueFrom: displayOld,
        fieldValueTo: displayNew,
        action
      });
    });
  } else {
    // 🆕 Created / Deleted
    this.eventHistoryBuffer.push({
      userID: this.authUser?.user?.id,
      eventID: eventId,
      fieldName: 'Termin',
      fieldValueFrom: 'neu',
      fieldValueTo: 'neu',
      action
    });
  }

  console.log('Aktueller Pufferinhalt:', this.eventHistoryBuffer);
  this.uploadBufferedEventHistory();
}


// 🔎 Hilfsfunktion: baut eine saubere Anzeige pro Informations-Eintrag
 displayInformation(i: any): string {
  if (!i) return '-';
  const parts: string[] = [];

  // Typ-spezifische Basis
  switch ((i.type || '').toLowerCase()) {
    case 'radio':
    case 'select':
      parts.push(i.value ? `Auswahl: ${i.value}` : 'Auswahl: -');
      break;

    case 'checkbox':
    case 'switch':
      parts.push(i.checked ? 'Ja' : 'Nein');
      break;

    default:
      // Fallback: wenn weder radio/select noch checkbox/switch → Info-Text oder Value
      if (typeof i.value === 'string' && i.value.trim()) {
        parts.push(`Wert: ${i.value}`);
      } else {
        parts.push(i.checked ? 'Ja' : 'Nein'); // falls vorhanden, sonst „Nein“
      }
      break;
  }

  // Zusatzfelder (falls vorhanden)
  if (i.info && String(i.info).trim()) {
    parts.push(`Info: ${String(i.info).trim()}`);
  }

  if (Array.isArray(i.options) && i.options.length) {
    const opt = i.options
      .map((o: any) => `${o?.name || ''} ${o?.info || ''}`.trim())
      .filter(Boolean)
      .join('; ');
    if (opt) parts.push(opt);
  }

  return parts.join(' | ') || '-';
}

  }
